import { http } from '../http'
import { URL } from './_constant'

/**
 * 部门管理-列表
 */
export function API_DEPARTMENT_LIST(data?: BasicPageReq) {
  return http.post<ApiDepartment.ListRes>(URL.LIST, data)
}

/**
 * 部门管理-全部
 */
export function API_DEPARTMENT_ALL(data?: BasicPageReq) {
  return http.post<ApiDepartment.Item[]>(URL.LIST, data)
}

/**
 * 部门管理-简单列表
 */
export function API_DEPARTMENT_SIMPLE_LIST(data?: BasicPageReq) {
  return http.post<BasicSimpleListItem[]>(URL.SIMPLE_LIST, data)
}

/**
 * 部门管理-搜索全部
 */
export function API_DEPARTMENT_SEARCH_ALL(conditionValue?: string) {
  const data: BD.Recordable = {}
  if (conditionValue) {
    data.conditions = [
      {
        conditionKeyName: 'stationName',
        conditionType: 'like',
        conditionValue,
        conditionLinkType: 'and'
      }
    ]
  }
  return http.post(URL.LIST, data)
}

/**
 * 部门管理-新增
 */
export function API_DEPARTMENT_ADD(data: ApiDepartment.Item) {
  return http.post(URL.ADD, data)
}

/**
 * 部门管理-删除
 */
export function API_DEPARTMENT_DEL(data: IdsPayload) {
  return http.post(URL.DEL, data)
}

/**
 *  部门管理-编辑
 */
export function API_DEPARTMENT_EDIT(data: BasicUpdateOneReq<ApiDepartment.Item>) {
  return http.post(URL.EDIT, data)
}

/**
 *  部门管理-禁用
 */
export function API_DEPARTMENT_DISABLE(data: IdsPayload) {
  return http.post(URL.DISABLE, data)
}
/**
 * 部门管理-启用
 */
export function API_DEPARTMENT_ENABLE(data: IdsPayload) {
  return http.post(URL.ENABLE, data)
}

/**
 * 部门管理-排序
 */
export function API_DEPARTMENT_ORDER(data: BasicOrderData) {
  return http.post(URL.ORDER, data)
}
